import React from 'react';
import * as Icons from 'lucide-react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { OPERATIONAL_SERVICES, PROCESS_SERVICES } from '../data/mock';

const SectionHeading = ({ title, highlight, subtitle, className = 'mt-0' }) => (
  <div className={className}>
    <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-center leading-tight">
      {title} <span className="gradient-text">{highlight}</span>
    </h2>
    <p className="mt-5 text-center text-white/55 max-w-2xl mx-auto">{subtitle}</p>
  </div>
);

const ArrowLink = ({ to, size = 18 }) => (
  <Link
    to={to}
    className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#1AB6FF]/30 text-[#1AB6FF] hover:bg-[#1AB6FF] hover:text-[#04070d] transition-colors"
  >
    <ArrowRight size={size} />
  </Link>
);

const FlagshipCard = ({ service }) => {
  const Icon = Icons[service.icon] || Sparkles;
  return (
    <div className="card-tech rounded-2xl p-7 group">
      <div className="w-14 h-14 rounded-full border-2 border-[#1AB6FF]/30 bg-[#1AB6FF]/5 flex items-center justify-center mb-5 group-hover:border-[#1AB6FF]/60 transition-colors">
        <Icon size={26} className="text-[#1AB6FF]" />
      </div>
      <h3 className="font-display font-semibold text-2xl text-white">{service.title}</h3>
      <p className="mt-2 text-white/55 text-sm">{service.desc}</p>
      <div className="mt-6">
        <ArrowLink to="/services" />
      </div>
    </div>
  );
};

const ProcessRow = ({ service }) => {
  const Icon = Icons[service.icon] || Sparkles;
  return (
    <div className="card-tech rounded-2xl p-6 group flex items-start gap-4">
      <div className="w-14 h-14 rounded-full border-2 border-[#1AB6FF]/30 bg-[#1AB6FF]/5 flex items-center justify-center shrink-0">
        <Icon size={24} className="text-[#1AB6FF]" />
      </div>
      <div className="flex-1">
        <h3 className="font-display font-semibold text-xl text-white">{service.title}</h3>
        <p className="mt-1 text-white/55 text-sm">{service.desc}</p>
      </div>
      <Link
        to="/services"
        className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-[#1AB6FF]/30 text-[#1AB6FF] hover:bg-[#1AB6FF] hover:text-[#04070d] transition-colors shrink-0"
      >
        <ArrowRight size={16} />
      </Link>
    </div>
  );
};

const FlagshipGrid = () => (
  <div className="mt-14 grid md:grid-cols-3 gap-6">
    {OPERATIONAL_SERVICES.map((s) => (
      <FlagshipCard key={s.title} service={s} />
    ))}
  </div>
);

const ProcessGrid = () => (
  <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
    {PROCESS_SERVICES.map((s) => (
      <ProcessRow key={s.title} service={s} />
    ))}
  </div>
);

const OperationalSystems = () => (
  <section className="relative py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <SectionHeading
        title="Operational Systems Built Around"
        highlight="Your Business"
        subtitle="Three flagship offerings powering modern Indian businesses — people, processes and AI working as one."
      />
      <FlagshipGrid />

      <SectionHeading
        className="mt-28"
        title="Built With Process."
        highlight="Scaled With Precision."
        subtitle="Modular, plug-in teams — deploy exactly the operational muscle your business needs."
      />
      <ProcessGrid />
    </div>
  </section>
);

export default OperationalSystems;
